import { createSelector } from 'reselect'

import { selectGeneralReportsState } from './selectGeneralReportsState'

export const selectGeneralReportSettings = createSelector(
  [selectGeneralReportsState],
  ({ data, selectedRtm }) => data.filter((report) => report.RTM.includes(selectedRtm))
)
